// All UI translation strings. Tool-specific labels stay in English.
export const translations = {
  en: {
    // Nav
    "nav.home": "Home",
    "nav.tools": "Tools",
    "nav.blog": "Blog",
    "nav.about": "About",
    "nav.contact": "Contact",
    "nav.favorites": "Favorites",
    "nav.signin": "Sign in",
    "nav.admin": "Admin",
    "nav.search_placeholder": "Search 23+ image tools...",
    "nav.install_app": "Install App",

    // Hero
    "hero.badge": "Runs entirely in your browser · No uploads",
    "hero.title_1": "Every image tool you need.",
    "hero.title_2": "One fast toolkit.",
    "hero.subtitle": "Compress, convert, crop, resize, and edit images with zero uploads. Private by default, instant by design.",
    "hero.cta_primary": "Explore all tools",
    "hero.cta_secondary": "Try Compressor",
    "hero.stat_tools": "Tools",
    "hero.stat_private": "Private",
    "hero.stat_uploaded": "Uploaded",

    // Sections
    "section.popular.title": "Popular tools",
    "section.popular.subtitle": "Loved by thousands of creators every day",
    "section.categories.title": "Browse by category",
    "section.categories.subtitle": "Find the right tool for the job",
    "section.latest.title": "Latest tools",
    "section.latest.subtitle": "Fresh additions to the toolkit",
    "section.faq.title": "Frequently asked questions",
    "section.faq.subtitle": "Everything you need to know",
    "categories.tools_count": "tools",

    // Newsletter
    "newsletter.title": "Get new tools in your inbox",
    "newsletter.subtitle": "One short email per month. No spam, unsubscribe anytime.",
    "newsletter.email_placeholder": "you@example.com",
    "newsletter.subscribe": "Subscribe",
    "newsletter.success": "You're on the list!",
    "newsletter.error": "Please enter a valid email",

    // Home FAQ
    "faq.q1": "Are these image tools free to use?",
    "faq.a1": "Yes — all ImageKitHub tools are 100% free with no signup required. They run entirely in your browser.",
    "faq.q2": "Do my images get uploaded to a server?",
    "faq.a2": "No. Every tool processes files locally in your browser. Your images never leave your device.",
    "faq.q3": "What formats are supported?",
    "faq.a3": "JPG, PNG, WebP, and more. Our converters support seamless swaps between all major raster formats.",
    "faq.q4": "Is there a file size limit?",
    "faq.a4": "Because processing is client-side, limits depend on your device. Most modern phones and laptops handle 20MB+ smoothly.",
    "faq.q5": "Can I use these tools on mobile?",
    "faq.a5": "Absolutely. ImageKitHub is fully responsive and mobile-first.",

    // Tools list
    "tools.title": "All image tools",
    "tools.subtitle": "Everything you need, right in your browser.",
    "tools.search_placeholder": "Search tools...",
    "tools.filter_all": "All",
    "tools.no_results": "No tools match your search.",

    // Tool page
    "tool.how_title": "How it works",
    "tool.how_1": "Upload or drag-drop your image into the tool area above.",
    "tool.how_2": "Adjust the settings to match your needs.",
    "tool.how_3": "Preview the result live in your browser — no upload, ever.",
    "tool.how_4": "Download the processed file to your device.",
    "tool.features_title": "Features",
    "tool.benefits_title": "Benefits",
    "tool.feature_1": "100% client-side processing",
    "tool.feature_2": "No signup or watermarks",
    "tool.feature_3": "Works offline once loaded",
    "tool.feature_4": "Batch-friendly workflow",
    "tool.benefit_1": "Complete privacy — nothing uploaded",
    "tool.benefit_2": "Instant results, no queues",
    "tool.benefit_3": "Works on mobile and desktop",
    "tool.benefit_4": "Free forever",
    "tool.faq_title": "Frequently asked",
    "tool.rate_title": "Rate this tool",
    "tool.rate_thanks": "Thanks for rating!",
    "tool.share_title": "Share",
    "tool.related_title": "Related tools",
    "tool.community_avg": "Community avg",
    "tool.comments_placeholder": "Community comments coming soon",
    "tool.favorite": "Add to favorites",
    "tool.unfavorite": "Remove from favorites",

    // Blog
    "blog.title": "The ImageKitHub Blog",
    "blog.subtitle": "Guides on image SEO, compression, WebP, PNG, JPG, and more.",
    "blog.empty": "No posts yet. Check back soon — or head to the admin panel to publish the first one.",
    "blog.back": "← Back to all posts",
    "blog.share": "Share:",

    // Favorites page
    "favorites.title": "Your favorite tools",
    "favorites.subtitle": "Tap the heart on any tool to pin it here.",
    "favorites.empty": "You haven't favorited any tools yet. Browse tools and tap the heart icon to add them.",

    // Footer
    "footer.tagline": "Fast, private, browser-based image tools. Compress, convert, edit — nothing leaves your device.",
    "footer.product": "Product",
    "footer.company": "Company",
    "footer.legal": "Legal",
    "footer.all_tools": "All Tools",
    "footer.privacy": "Privacy",
    "footer.terms": "Terms",
    "footer.cookies": "Cookies",
    "footer.dmca": "DMCA",
    "footer.disclaimer": "Disclaimer",
    "footer.copyright": "All rights reserved.",
    "footer.built": "Built for creators. Runs entirely in your browser.",

    // Contact
    "contact.title": "Get in touch",
    "contact.subtitle": "We usually reply within 24 hours.",
    "contact.name": "Name",
    "contact.email": "Email",
    "contact.message": "Message",
    "contact.send": "Send message",
    "contact.sending": "Sending…",
    "contact.success": "Message sent — we'll be in touch.",
    "contact.error": "Failed to send",

    // 404
    "404.title": "This page went for a walk.",
    "404.subtitle": "The link may be broken, or the page moved. Let's get you back home.",
    "404.home": "Go home",
    "404.tools": "Browse tools",

    // Misc
    "loading": "Loading…",
    "coming_soon": "is coming soon",
    "coming_soon_desc": "We're polishing this experience. Meanwhile, explore our other production-ready tools below.",
    "install.prompt": "Install ImageKitHub as an app",
    "install.button": "Install",
    "install.later": "Later",
    "offline.badge": "You're offline — client-side tools still work",
  },
  hi: {
    // Nav
    "nav.home": "होम",
    "nav.tools": "टूल्स",
    "nav.blog": "ब्लॉग",
    "nav.about": "हमारे बारे में",
    "nav.contact": "संपर्क",
    "nav.favorites": "पसंदीदा",
    "nav.signin": "साइन इन",
    "nav.admin": "एडमिन",
    "nav.search_placeholder": "23+ इमेज टूल्स खोजें...",
    "nav.install_app": "ऐप इंस्टॉल करें",

    // Hero
    "hero.badge": "पूरी तरह से आपके ब्राउज़र में चलता है · कोई अपलोड नहीं",
    "hero.title_1": "आपको ज़रूरी हर इमेज टूल।",
    "hero.title_2": "एक तेज़ टूलकिट।",
    "hero.subtitle": "बिना अपलोड किए इमेज कंप्रेस, कन्वर्ट, क्रॉप, रीसाइज़ और एडिट करें। डिफ़ॉल्ट रूप से प्राइवेट, डिज़ाइन से इंस्टेंट।",
    "hero.cta_primary": "सभी टूल्स देखें",
    "hero.cta_secondary": "कंप्रेसर आज़माएं",
    "hero.stat_tools": "टूल्स",
    "hero.stat_private": "प्राइवेट",
    "hero.stat_uploaded": "अपलोड",

    // Sections
    "section.popular.title": "लोकप्रिय टूल्स",
    "section.popular.subtitle": "हज़ारों क्रिएटर्स रोज़ इस्तेमाल करते हैं",
    "section.categories.title": "श्रेणी से ब्राउज़ करें",
    "section.categories.subtitle": "अपने काम के लिए सही टूल चुनें",
    "section.latest.title": "नए टूल्स",
    "section.latest.subtitle": "टूलकिट में नए जोड़",
    "section.faq.title": "अक्सर पूछे जाने वाले सवाल",
    "section.faq.subtitle": "जो कुछ आपको जानना चाहिए",
    "categories.tools_count": "टूल्स",

    // Newsletter
    "newsletter.title": "नए टूल्स सीधे अपने इनबॉक्स में पाएं",
    "newsletter.subtitle": "महीने में एक छोटा ईमेल। कोई स्पैम नहीं, कभी भी अनसब्सक्राइब करें।",
    "newsletter.email_placeholder": "you@example.com",
    "newsletter.subscribe": "सब्सक्राइब करें",
    "newsletter.success": "आप लिस्ट में हैं!",
    "newsletter.error": "कृपया मान्य ईमेल दर्ज करें",

    // Home FAQ
    "faq.q1": "क्या ये इमेज टूल्स इस्तेमाल करने के लिए मुफ़्त हैं?",
    "faq.a1": "हाँ — ImageKitHub के सभी टूल्स 100% मुफ़्त हैं, कोई साइनअप ज़रूरी नहीं। ये पूरी तरह आपके ब्राउज़र में चलते हैं।",
    "faq.q2": "क्या मेरी इमेज सर्वर पर अपलोड होती हैं?",
    "faq.a2": "नहीं। हर टूल फ़ाइलें आपके ब्राउज़र में लोकली प्रोसेस करता है। आपकी इमेज कभी आपकी डिवाइस नहीं छोड़ती।",
    "faq.q3": "कौन-कौन से फ़ॉर्मेट सपोर्टेड हैं?",
    "faq.a3": "JPG, PNG, WebP और अन्य। हमारे कन्वर्टर सभी बड़े रैस्टर फ़ॉर्मेट्स के बीच आसान बदलाव करते हैं।",
    "faq.q4": "क्या फ़ाइल साइज़ की कोई सीमा है?",
    "faq.a4": "प्रोसेसिंग क्लाइंट-साइड है इसलिए सीमा आपके डिवाइस पर निर्भर है। ज़्यादातर मॉडर्न फ़ोन/लैपटॉप 20MB+ आराम से हैंडल करते हैं।",
    "faq.q5": "क्या मैं मोबाइल पर ये टूल्स इस्तेमाल कर सकता हूँ?",
    "faq.a5": "बिल्कुल। ImageKitHub पूरी तरह रेस्पॉन्सिव और मोबाइल-फ़र्स्ट है।",

    // Tools list
    "tools.title": "सभी इमेज टूल्स",
    "tools.subtitle": "जो कुछ चाहिए, सीधे आपके ब्राउज़र में।",
    "tools.search_placeholder": "टूल्स खोजें...",
    "tools.filter_all": "सभी",
    "tools.no_results": "आपकी खोज से कोई टूल मैच नहीं करता।",

    // Tool page
    "tool.how_title": "यह कैसे काम करता है",
    "tool.how_1": "ऊपर दिए गए एरिया में अपनी इमेज अपलोड या ड्रैग-ड्रॉप करें।",
    "tool.how_2": "अपनी ज़रूरत के अनुसार सेटिंग्स एडजस्ट करें।",
    "tool.how_3": "अपने ब्राउज़र में लाइव रिज़ल्ट देखें — कोई अपलोड नहीं।",
    "tool.how_4": "प्रोसेस्ड फ़ाइल अपने डिवाइस पर डाउनलोड करें।",
    "tool.features_title": "फ़ीचर्स",
    "tool.benefits_title": "फ़ायदे",
    "tool.feature_1": "100% क्लाइंट-साइड प्रोसेसिंग",
    "tool.feature_2": "कोई साइनअप या वॉटरमार्क नहीं",
    "tool.feature_3": "एक बार लोड होने के बाद ऑफ़लाइन काम करता है",
    "tool.feature_4": "बैच-फ्रेंडली वर्कफ़्लो",
    "tool.benefit_1": "पूरी प्राइवेसी — कुछ भी अपलोड नहीं",
    "tool.benefit_2": "तुरंत रिज़ल्ट, कोई कतार नहीं",
    "tool.benefit_3": "मोबाइल और डेस्कटॉप दोनों पर चलता है",
    "tool.benefit_4": "हमेशा मुफ़्त",
    "tool.faq_title": "अक्सर पूछे जाते हैं",
    "tool.rate_title": "इस टूल को रेट करें",
    "tool.rate_thanks": "रेटिंग के लिए धन्यवाद!",
    "tool.share_title": "शेयर करें",
    "tool.related_title": "मिलते-जुलते टूल्स",
    "tool.community_avg": "कम्युनिटी औसत",
    "tool.comments_placeholder": "कम्युनिटी कमेंट्स जल्द आ रहे हैं",
    "tool.favorite": "पसंदीदा में जोड़ें",
    "tool.unfavorite": "पसंदीदा से हटाएं",

    // Blog
    "blog.title": "ImageKitHub ब्लॉग",
    "blog.subtitle": "इमेज SEO, कंप्रेशन, WebP, PNG, JPG और अन्य पर गाइड्स।",
    "blog.empty": "अभी कोई पोस्ट नहीं। जल्द वापस आइए — या एडमिन पैनल से पहली पोस्ट पब्लिश करें।",
    "blog.back": "← सभी पोस्ट्स पर वापस",
    "blog.share": "शेयर करें:",

    // Favorites
    "favorites.title": "आपके पसंदीदा टूल्स",
    "favorites.subtitle": "किसी भी टूल पर हार्ट टैप करके यहाँ पिन करें।",
    "favorites.empty": "आपने अभी तक कोई टूल पसंदीदा नहीं जोड़ा। टूल्स ब्राउज़ करें और हार्ट आइकन टैप करें।",

    // Footer
    "footer.tagline": "तेज़, प्राइवेट, ब्राउज़र-आधारित इमेज टूल्स। कंप्रेस, कन्वर्ट, एडिट — कुछ भी आपकी डिवाइस नहीं छोड़ता।",
    "footer.product": "प्रोडक्ट",
    "footer.company": "कंपनी",
    "footer.legal": "कानूनी",
    "footer.all_tools": "सभी टूल्स",
    "footer.privacy": "प्राइवेसी",
    "footer.terms": "नियम",
    "footer.cookies": "कुकीज़",
    "footer.dmca": "DMCA",
    "footer.disclaimer": "डिस्क्लेमर",
    "footer.copyright": "सर्वाधिकार सुरक्षित।",
    "footer.built": "क्रिएटर्स के लिए बना। पूरी तरह आपके ब्राउज़र में चलता है।",

    // Contact
    "contact.title": "संपर्क में रहें",
    "contact.subtitle": "हम आमतौर पर 24 घंटे के अंदर जवाब देते हैं।",
    "contact.name": "नाम",
    "contact.email": "ईमेल",
    "contact.message": "संदेश",
    "contact.send": "संदेश भेजें",
    "contact.sending": "भेज रहे हैं…",
    "contact.success": "संदेश भेज दिया — हम जल्द संपर्क करेंगे।",
    "contact.error": "भेजने में विफल",

    // 404
    "404.title": "यह पेज कहीं टहलने चला गया।",
    "404.subtitle": "लिंक टूट सकता है या पेज हट गया हो। चलिए आपको होम पर वापस ले चलते हैं।",
    "404.home": "होम जाएं",
    "404.tools": "टूल्स देखें",

    // Misc
    "loading": "लोड हो रहा है…",
    "coming_soon": "जल्द आ रहा है",
    "coming_soon_desc": "हम इस अनुभव को बेहतर बना रहे हैं। तब तक नीचे दिए गए अन्य टूल्स देखें।",
    "install.prompt": "ImageKitHub को ऐप के रूप में इंस्टॉल करें",
    "install.button": "इंस्टॉल",
    "install.later": "बाद में",
    "offline.badge": "आप ऑफ़लाइन हैं — क्लाइंट-साइड टूल्स फिर भी काम करते हैं",
  },
};
